// apps/web/src/self-service/NotFoundCard.tsx — Phase 4 follow-up #2.
//
// Phase 4 follow-up #2: when a URL like /reservierung/datum is visited
// (the wizard's verb namespace is /reservieren/, not /reservierung/ —
// see main.tsx:202-219), React Router matched the `:token` param and
// the previous SelfServicePage rendered the `tokenInvalid` fallback.
// That copy implied the guest's real link had expired, which is not
// what happened — the URL was just wrong. This card is the correct
// surface for the "obviously-not-a-token" case so the message matches
// reality and the user gets a way back to the start page.
//
// The card is intentionally minimal (no API call, no reservation
// summary) so it's safe to render BEFORE any token-validation round
// trip and inside a React.lazy / SSR boundary. It uses the same
// chrome tokens (bg / surface / divider / accent) as FallbackCard
// (SelfServicePage.tsx:418) for visual consistency.

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function NotFoundCard(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className="w-full max-w-[440px] bg-bg border border-divider rounded-[14px] shadow-sm p-4"
      data-testid="a8-not-found"
      role="alert"
    >
      <h1
        className="font-heading text-2xl md:text-3xl mb-2"
        data-testid="a8-not-found-title"
      >
        {t("wizard.notFound.title")}
      </h1>
      <p className="text-sm text-text/80" data-testid="a8-not-found-body">
        {t("wizard.notFound.body")}
      </p>
      <Link
        to="/"
        className="mt-4 min-h-[44px] inline-flex items-center justify-center px-4 py-2 rounded-md border border-accent text-accent-700 hover:bg-accent-100"
        data-testid="a8-not-found-home"
      >
        {t("wizard.notFound.home")}
      </Link>
    </div>
  );
}
